import React, {useEffect, useRef, useState} from 'react'
import Typography from "@mui/material/Typography"
import Button from "@mui/material/Button"
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton"
import CloseIcon from "@mui/icons-material/Close"
import {green, red, orange, blue} from "@mui/material/colors";
import {useGlobalContext} from "../../contexts/global_context";
import {BACKEND_URL} from "../../data/config";

const HeaderNotification = () => {
  const storageName = 'dismissedServiceAlert'
  const {sendAjax} = useGlobalContext()

  const [enabled, setEnabled] = useState(false)
  const [messageHtml, setMessageHtml] = useState('')
  const [type, setType] = useState(10)
  const [loaded, setLoaded] = useState(false)

  const checkAlertDismissal = () => {
    const dismissedData = localStorage.getItem(storageName)
    if (!dismissedData) return false
    try {
      const {timestamp} = JSON.parse(dismissedData)
      const oneMonthAgo = Date.now() - (30 * 24 * 60 * 60 * 1000)
      return timestamp > oneMonthAgo
    } catch {
      return false
    }
  }

  const [dismissed, setDismissed] = useState(checkAlertDismissal())
  const containerRef = useRef(null)

  useEffect(() => {
    sendAjax({
      url: `${BACKEND_URL}/api/v1/notifications/top/`,
      method: 'get',
      data: {},
    }).then(r => {
      if (r.data && r.data.status_code === 200) {
        const d = r.data.data
        setEnabled(!!d.enabled)
        setMessageHtml(d.message_html || '')
        setType(d.notification_type || 10)
      }
      setLoaded(true)
    }).catch(() => setLoaded(true))
  }, [])

  // Keep Navbar offset in sync with the top notification height
  useEffect(() => {
    const setOffsetVar = () => {
      try {
        if (enabled && !dismissed && messageHtml && containerRef.current) {
          const h = containerRef.current.offsetHeight - 1 || 0
          document.documentElement.style.setProperty('--topnotif-h', `${h}px`)
        } else {
          document.documentElement.style.setProperty('--topnotif-h', '0px')
        }
      } catch (_) {
        // ignore
      }
    }

    setOffsetVar()

    window.addEventListener('resize', setOffsetVar)
    return () => {
      window.removeEventListener('resize', setOffsetVar)
      // reset on unmount/cleanup
      document.documentElement.style.setProperty('--topnotif-h', '0px')
    }
  }, [enabled, dismissed, messageHtml, loaded])

  const dismissAlert = () => {
    const dismissalData = {timestamp: Date.now()}
    localStorage.setItem(storageName, JSON.stringify(dismissalData))
    setDismissed(true)
  }

  const getBgColor = () => {
    switch (type) {
      case 10: // success
        return green[500]
      case 20: // danger
        return red[500]
      case 30: // warning
        return orange[600]
      case 40: // primary
        return blue[600]
      default:
        return green[500]
    }
  }

  if (!loaded || !enabled || dismissed || !messageHtml) return null

  return (
    <Box
      ref={containerRef}
      bgcolor={getBgColor()}
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: (theme) => theme.zIndex.appBar + 1,
        textAlign: 'center',
      }}
    >
      <Box
        sx={{
          paddingTop: 0.25,
          paddingLeft: 1,
          paddingRight: 1,
          paddingBottom: 0.25,
        }}
      >
        <Typography variant="body2" color={'white'}>
          <span dangerouslySetInnerHTML={{__html: messageHtml}}/>
          <IconButton
            size="small"
            aria-label="Dismiss notification"
            onClick={dismissAlert}

            sx={{
              color: 'white',
              padding: 0,
              marginLeft: 1,
              marginTop: -0.3,
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.15)',
              }
            }}
          >
            <CloseIcon fontSize="small" sx={{fontSize: '1.1rem'}}/>
          </IconButton>
        </Typography>
      </Box>
    </Box>
  )
}

export default HeaderNotification
